import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { ADMIN_USER_API_PATH, BASE_URL } from 'constants/api';
import { UserInterface } from 'account/user/types/userType';
import { FetchResult } from 'type/apiType';

/**
 * subtitle-vendor Role의 PK. `/api/v1/roles/` 응답에서 확인.
 * prod 전환 시 환경별로 다를 수 있으므로 env로 뺄지 검토 필요.
 */
const SUBTITLE_VENDOR_ROLE_ID = 3;

/**
 * `subtitle-vendor` role을 가진 어드민 사용자 목록.
 * BE의 GET /accounts/admin/users/?role_id=<id> 필터 사용.
 */
export const useSubtitleVendorUsers = () => {
  return useQuery<UserInterface[]>({
    queryKey: ['subtitle-vendor-users', SUBTITLE_VENDOR_ROLE_ID],
    queryFn: async () => {
      const response = await axios.get<FetchResult<UserInterface>>(
        `${BASE_URL}${ADMIN_USER_API_PATH}`,
        { params: { role_id: SUBTITLE_VENDOR_ROLE_ID, page: 1, page_size: 100 } }
      );
      return response.data.results ?? [];
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
